import { autoType } from '../types/autoUserSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleResponse, MyAxios } from '@services/SettingAxios';
import { wrapperFetchCheckedValidateToken } from '@sharedHelpers/wrapperFetchCheckedValidateToken';
import { ServiceCookies } from '@services/ServiceCookies';

export const fetchUserAutoList = createAsyncThunk<autoType[], null, { rejectValue: { code: number } }>(
  'autoUser/fetchUserAutoList',
  async (_, { rejectWithValue }) => {
    try {
      return await wrapperFetchCheckedValidateToken(async () => {
        return await MyAxios.get('/api/user/auto', {
          headers: {
            [ServiceCookies.JWT_HEADER]: ServiceCookies.jwtAccess,
          },
        }).then(handleResponse);
      });
    } catch (error) {
      const code = error.response?.status;
      return rejectWithValue({ code });
    }
  },
);
